import Cookies from 'js-cookie';
import {
  getPreferencesCookieName,
  getDefaultPreferences,
} from '@/config/preferences';
import { PreferencesStore } from '@/stores/preferences';

/**
 * Gets the user's preferred home page path.
 * Tries to read from PreferencesStore first (includes DB data when available),
 * falls back to cookie if store is not loaded.
 * Returns '/chat' or '/dashboard' based on user preference.
 */
export function getHomePage(userId?: string): string {
  if (typeof window === 'undefined') {
    const defaults = getDefaultPreferences();
    return `/${defaults.homePage || 'dashboard'}`;
  }

  // Try to get from PreferencesStore first (more up-to-date)
  try {
    const { preferences, isLoaded } = PreferencesStore.getState();
    if (isLoaded && preferences.homePage) {
      return `/${preferences.homePage}`;
    }
  } catch {
    // Store not available, fall through to cookie
  }

  // Fallback to cookie (for fast initial load or when store not ready)
  try {
    const cookieName = getPreferencesCookieName(userId);
    const cookieValue = Cookies.get(cookieName);
    if (!cookieValue) {
      const defaults = getDefaultPreferences();
      return `/${defaults.homePage || 'dashboard'}`;
    }

    const preferences = JSON.parse(cookieValue);
    const homePage = preferences.homePage || 'dashboard';

    return `/${homePage}`;
  } catch {
    return '/dashboard';
  }
}
